class CartUpsellComponent extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.handleVariantChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.handleVariantChange);
  }

  handleVariantChange = (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-upsell-variant]')) return;

    const option = select.selectedOptions[0];
    const form = this.querySelector('product-form-component');
    if (!option || !form) return;

    form.querySelector('input[name="id"]').value = option.value;
    form.querySelector('input[name="quantity"]').value = option.dataset.minimum;
    form.dataset.quantityDefault = option.dataset.minimum;
    this.querySelector('[data-upsell-price]').textContent = option.dataset.price;
    const error = form.querySelector('[ref="addToCartTextError"]');
    error?.classList.add('hidden');
  };
}

if (!customElements.get('cart-upsell-component')) {
  customElements.define('cart-upsell-component', CartUpsellComponent);
}
